// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.j7jR7Nha4iPVAD {
  display: block;
  position: relative;
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  float: left;
  border-radius: 8px;
}
.j7jR7Nha4iPVAD:hover {
  background-color: var(--ds-background-neutral, #091e420f);
}
.EIHQOg7omzzsJV:hover {
  background-color: var(--ds-background-neutral-subtle-hovered, hsla(0, 0%, 0%, 0.08));
}
.LI6cSzZ5lP5VDO {
  display: inline-block;
  position: relative;
  flex: 0 0 auto;
  width: 40px;
  height: 32px;
  border-radius: 4px;
  opacity: 1;
  background-size: cover;
}
.dOHQrJ3suHjGk3 {
  display: flex;
  position: relative;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  padding: 0 0 0 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.sbH1oOdCq1rMAx {
  flex-direction: column;
  padding-top: 0;
  padding-bottom: 0;
}
.FXLR9mrG5PF4sF {
  color: var(--ds-text, #172b4d);
  font-size: 14px;
  font-weight: var(--ds-font-weight-medium, 500);
  line-height: 18px;
}
.DbTZHBV6iS6r8N {
  color: var(--ds-text-subtlest, #626f86);
  font-size: 12px;
  font-weight: var(--ds-font-weight-regular, 400);
  line-height: 16px;
}
.FXLR9mrG5PF4sF,
.DbTZHBV6iS6r8N {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.OMbiF7COwO08ve {
  position: absolute;
  top: -4px;
  left: 35px;
  width: 8px;
  height: 8px;
  border: 2px solid var(--ds-surface, #ffffff);
  border-radius: 8px;
  background-color: var(--ds-icon-brand, #0c66e4);
}
.DzaSrwPahPYolK {
  display: flex;
  width: 0;
}
.DzaSrwPahPYolK.aIFFtWQZ0tAvDr {
  width: auto;
}
.o0j0pqCMsKJEE7 {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 0;
  overflow: hidden;
}
.o0j0pqCMsKJEE7.aIFFtWQZ0tAvDr {
  width: 24px;
}
.Kczws6fqM9yotm {
  display: flex;
  position: relative;
  height: 32px;
  padding: 4px 8px 4px 4px;
  border-radius: 8px;
  font-weight: var(--ds-font-weight-bold, 700);
  text-decoration: none;
  -webkit-user-select: none;
          user-select: none;
}
.Kczws6fqM9yotm:hover,
.Kczws6fqM9yotm:focus,
.Kczws6fqM9yotm:focus-within {
  text-decoration: none;
}
.Kczws6fqM9yotm:hover .OMbiF7COwO08ve.I9iWdCirWlMsqH,
.Kczws6fqM9yotm:focus .OMbiF7COwO08ve.I9iWdCirWlMsqH,
.Kczws6fqM9yotm:focus-within .OMbiF7COwO08ve.I9iWdCirWlMsqH {
  margin-right: 4px;
}
.Kczws6fqM9yotm:hover .DzaSrwPahPYolK,
.Kczws6fqM9yotm:focus .DzaSrwPahPYolK,
.Kczws6fqM9yotm:focus-within .DzaSrwPahPYolK {
  width: auto;
}
.Kczws6fqM9yotm:hover .o0j0pqCMsKJEE7,
.Kczws6fqM9yotm:focus .o0j0pqCMsKJEE7,
.Kczws6fqM9yotm:focus-within .o0j0pqCMsKJEE7 {
  display: flex;
  overflow: visible;
}
.Kczws6fqM9yotm:hover .o0j0pqCMsKJEE7.FM_2sCOdIJO_oB,
.Kczws6fqM9yotm:focus .o0j0pqCMsKJEE7.FM_2sCOdIJO_oB,
.Kczws6fqM9yotm:focus-within .o0j0pqCMsKJEE7.FM_2sCOdIJO_oB {
  width: 24px;
}
.N8v4GlPedxL7gl {
  display: flex;
  position: relative;
  flex-direction: column;
  justify-content: center;
  padding: 0 8px 0 0;
}
.PNr7e05RUxUaoc {
  background-color: var(--ds-background-neutral-hovered, #091e4224);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"boardTile": `j7jR7Nha4iPVAD`,
	"relatedTemplates": `EIHQOg7omzzsJV`,
	"boardThumbnail": `LI6cSzZ5lP5VDO`,
	"boardDescription": `dOHQrJ3suHjGk3`,
	"fullHeight": `sbH1oOdCq1rMAx`,
	"boardName": `FXLR9mrG5PF4sF`,
	"boardSubName": `DbTZHBV6iS6r8N`,
	"unreadMarker": `OMbiF7COwO08ve`,
	"actionsWrapper": `DzaSrwPahPYolK`,
	"isStarred": `aIFFtWQZ0tAvDr`,
	"utilityAction": `o0j0pqCMsKJEE7`,
	"boardLink": `Kczws6fqM9yotm`,
	"isUnread": `I9iWdCirWlMsqH`,
	"actionSmall": `FM_2sCOdIJO_oB`,
	"boardTemplateBadgeContainer": `N8v4GlPedxL7gl`,
	"boardTemplateBadge": `PNr7e05RUxUaoc`
};
export default ___CSS_LOADER_EXPORT___;
